import { FC, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { AxiosProgressEvent } from "axios"

import { UFileProcessingCard } from "../../../components"
import { Grid } from "../../../components/mui.components"
import { useAppDispatch } from "../../../core/app/hooks"
import { uploadXray } from "../../../core/app/slices/records/xrays/xraysThunkApi"

const UploadXrayProcessing: FC<{
  file: File
  onRemove: (f: any) => void
  onUploadSuccess?: (val: boolean) => void
  xrayType: string
}> = ({ file, onRemove, onUploadSuccess, xrayType }) => {
  const [progressValue, setProgressValue] = useState<number>(0)
  const [progressstatus, setProgresssStatus] = useState<
    "loading" | "complete" | "failed"
  >("loading")

  const dispatch = useAppDispatch()
  const { patientId, caseId } = useParams()

  useEffect(() => {
    console.log(xrayType)
    const newFile = new File([file], `${xrayType}.${file.type.split("/")[1]}`, {
      type: file.type,
    })
    const formPayload = new FormData()
    formPayload.append("attachment", newFile)
    formPayload.append("original_file_name", file.name)
    dispatch(
      uploadXray({
        patientId: patientId,
        caseId: caseId,
        formData: formPayload,
        fileName: newFile.name,
        orgId: "",
        onFileProcesscallback: function (progress: AxiosProgressEvent): void {
          const { loaded, total } = progress
          setProgresssStatus("loading")
          const percentageProgress = Math.floor((loaded / total) * 100)
          setProgressValue(percentageProgress)
          console.log(
            "...onFileProcesscallback....",
            loaded,
            total,
            percentageProgress,
          )
        },
      }),
    ).then((action) => {
      if (action.payload.status === 200) {
        setProgresssStatus("complete")
        onUploadSuccess && onUploadSuccess(true)
      } else {
        setProgresssStatus("failed")
      }
    })
  }, [file])

  return (
    <>
      <UFileProcessingCard
        fileName={file.name}
        fileSize={file.size}
        progressValue={progressValue}
        progressstatus={progressstatus}
        onRemove={() => onRemove(file)}
      />
    </>
  )
}

export default UploadXrayProcessing
